import { render, staticRenderFns } from "./searchFormComponent.vue?vue&type=template&id=6d3d996d"
import script from "./searchFormComponent.vue?vue&type=script&lang=js"
export * from "./searchFormComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports